import { create } from "zustand";
import { WinningNumber } from "../../services/game_service";


export const fieldLabels: Record<keyof CheckNumberForm, string> = {
  threeDigitUpper: "3 ตัวบน",
  twoDigitLower: "2 ตัวล่าง",
  threeDigitLower: "3 ตัวล่าง",
  rateThreeUpper: "อัตรา 3 ตัวบน",
  rateThreeShuffle: "อัตรา 3 ตัวโต๊ด",
  rateTwoUpper: "อัตรา 2 ตัวบน",
  rateTwoShuffle: "อัตรา 2 ตัวโต๊ด",
  rateUpperRun: "อัตรา วิ่งบน",
  rateThreeLower: "อัตรา 3 ตัวล่าง",
  rateTwoLower: "อัตรา 2 ตัวล่าง",
  rateLowerRun: "อัตรา วิ่งล่าง",
  rateForthFloating: "อัตรา 4 ตัวลอย",
  rateFifthFloating: "อัตรา 5 ตัวลอย",
  threeLowerWinningNumber1: "",
  threeLowerWinningNumber2: "",
  threeLowerWinningNumber3: "",
  threeLowerWinningNumber4: ""
};

export interface CheckNumberForm {
  threeDigitUpper: string;
  twoDigitLower: string;
  threeDigitLower: string;
  rateThreeUpper: string;
  rateThreeShuffle: string;
  rateTwoUpper: string;
  rateTwoShuffle: string;
  rateUpperRun: string;
  rateThreeLower: string;
  rateTwoLower: string;
  rateLowerRun: string;
  rateForthFloating: string;
  rateFifthFloating: string;
  threeLowerWinningNumber1?: string;
  threeLowerWinningNumber2?: string;
  threeLowerWinningNumber3?: string;
  threeLowerWinningNumber4?: string;
}

interface CheckNumberFormState {
  form: CheckNumberForm | null | undefined;
  setForm: (form: any) => void;
  mapFormToWinningPayload: (form: CheckNumberForm) => WinningNumber;
  mapWinningResponseToForm: (form: WinningNumber) => CheckNumberForm;

}

export const useCheckNumberFormState = create<CheckNumberFormState>((set) => ({
  form: {
    threeDigitUpper: '',
    twoDigitLower: '',
    threeDigitLower: '',
    rateThreeUpper: '100 %',
    rateThreeShuffle: '100 %',
    rateTwoUpper: '100 %',
    rateTwoShuffle: '100 %',
    rateUpperRun: '100 %',
    rateThreeLower: '100 %',
    rateTwoLower: '100 %',
    rateLowerRun: '100 %',
    rateForthFloating: '100 %',
    rateFifthFloating: '100 %',
  },
  setForm: (form) => set({ form }),
  mapFormToWinningPayload: (form) => mapFormToWinningPayload(form),
  mapWinningResponseToForm: (res) => mapWinningResponseToForm(res),
}));

export function mapWinningResponseToForm(res: WinningNumber): CheckNumberForm {
  return {
    threeDigitUpper: `${res.threeUpperWinningNumber ?? ''}`,
    twoDigitLower: `${res.twoLowerWinningNumber ?? ''}`,
    threeDigitLower: `${res.threeLowerWinningNumber1 ?? ''}-${res.threeLowerWinningNumber2 ?? ''}-${res.threeLowerWinningNumber3 ?? ''}-${res.threeLowerWinningNumber4 ?? ''}`,
    rateThreeUpper: `${res.threeUpperStraightWinningPercent} %`,
    rateThreeShuffle: `${res.threeShuffleWinningPercent} %`,
    rateTwoUpper: `${res.twoUpperStraightWinningPercent} %`,
    rateTwoShuffle: `${res.twoShuffleWinningPercent} %`,
    rateUpperRun: `${res.upperRunningWinningPercent} %`,
    rateThreeLower: `${res.threeLowerStraightWinningPercent} %`,
    rateTwoLower: `${res.twoLowerStraightWinningPercent} %`,
    rateLowerRun: `${res.lowerRunningWinningPercent} %`,
    rateForthFloating: `${res.fourFloatingWinningPercent} %`,
    rateFifthFloating: `${res.fiveFloatingWinningPercent} %`,
  };
}

export function mapFormToWinningPayload(form: CheckNumberForm): WinningNumber {
  const [threeLower1 = '', threeLower2 = '', threeLower3 = '', threeLower4 = ''] = form.threeDigitLower
    .split('-')
    .map((s) => s.trim());

  return {
    threeUpperWinningNumber: form.threeDigitUpper ?? '',
    twoLowerWinningNumber: form.twoDigitLower ?? '',
    threeLowerWinningNumber1: threeLower1 ?? '',
    threeLowerWinningNumber2: threeLower2 ?? '',
    threeLowerWinningNumber3: threeLower3 ?? '',
    threeLowerWinningNumber4: threeLower4 ?? '',
    threeUpperStraightWinningPercent: parsePercent(form.rateThreeUpper),
    threeShuffleWinningPercent: parsePercent(form.rateThreeShuffle),
    twoUpperStraightWinningPercent: parsePercent(form.rateTwoUpper),
    twoShuffleWinningPercent: parsePercent(form.rateTwoShuffle),
    upperRunningWinningPercent: parsePercent(form.rateUpperRun),
    threeLowerStraightWinningPercent: parsePercent(form.rateThreeLower),
    twoLowerStraightWinningPercent: parsePercent(form.rateTwoLower),
    lowerRunningWinningPercent: parsePercent(form.rateLowerRun),
    fourFloatingWinningPercent: parsePercent(form.rateForthFloating),
    fiveFloatingWinningPercent: parsePercent(form.rateFifthFloating),
  };
}

function parsePercent(value: string): number {
  // แปลงจาก "100 %" เป็น 100
  const parsed = parseFloat(value.replace('%', '').trim());
  return isNaN(parsed) ? 0 : parsed;
}